export default {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};


//////////////////
// WEBPACK FOOTER
// ../~/_rc-calendar@9.15.5@rc-calendar/es/date/DateConstants.js
// module id = 598
// module chunks = 0